export { default } from './Tab';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Tab/index.js
// module id = 357
// module chunks = 0